import { apiClient, Auth } from '@/shared/api'

import { TContractReceiptBillUrl } from '../model/schema'

export const getGuestReceiptBillUrl = async (contractId: number) => {
  const response = await apiClient.get<TContractReceiptBillUrl>({
    endpoint: `/guest/contracts/${contractId}/receipt-info/bill-url`,
    auth: Auth.REQUIRED,
  })

  return response
}
